export default "__VITE_ASSET__Dv2MJgLB__"